import { render, staticRenderFns } from "./ProjectSelectOrCreateDialog.vue?vue&type=template&id=d48a024a"
import script from "./ProjectSelectOrCreateDialog.vue?vue&type=script&lang=js"
export * from "./ProjectSelectOrCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports